// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".btn-outline-primary[data-v-0bc27977]:hover {\n  color: #fff !important;\n}\n", ""]);
// Exports
module.exports = exports;
